<template>
  <div class="home">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--轮播图-->
    <header-banner :noticeList="noticeList" :advert="advert.banner"></header-banner>

    <div class="container">
      <!--广告位-->
      <div
        class="advert-box"
        v-if="advert.banner_bottom && advert.banner_bottom.images"
        :style="`background-image: url('${API_URL + advert.banner_bottom.images}')`"
        @click="onJumpPages(advert.banner_bottom.link)"
      ></div>
      <!--商品列表-->
      <div class="gift-list clearfix">
        <div
          class="advert-item"
          v-if="advert.goods_one && advert.goods_one.images"
          :style="`background-image: url('${API_URL + advert.goods_one.images}')`"
          @click="onJumpPages(advert.goods_one.link)"
        ></div>
        <gift-item v-for="(item, index) in goodsList" v-if="index <= 1" :key="item.id" :item="item"></gift-item>
        <div
          class="advert-item"
          v-if="advert.goods_two && advert.goods_two.images"
          :style="`background-image: url('${API_URL + advert.goods_two.images}')`"
          @click="onJumpPages(advert.goods_two.link)"
        ></div>

        <gift-item v-for="(item, index) in goodsList" v-if="index > 1" :key="item.id" :item="item"></gift-item>
      </div>
      <!--广告位-->
      <div
        class="advert-box"
        v-if="advert.goods_bottom && advert.goods_bottom.images"
        :style="`background-image: url('${API_URL + advert.goods_bottom.images}')`"
        @click="onJumpPages(advert.goods_bottom.link)"
      ></div>

      <!--合作伙伴-->
      <!--
      <div class="partners noSelect">
        <div class="partners-top">
          <p class="partners-top-title">网站合作伙伴</p>
          <p class="partners-top-tips">做全网全品类和服务供给，接入全网平台</p>
        </div>
        <div class="partners-content">
          <div class="partners-list">
            <div class="partners-item">
              <img class="partners-item-icon" :src="IMG_URL+'images/order/pdd-icon.png'" alt="">
              <p class="partners-item-name">拼多多</p>
            </div>
            <div class="partners-item">
              <img class="partners-item-icon" :src="IMG_URL+'images/order/tb-icon.png'" alt="">
              <p class="partners-item-name">淘宝</p>
            </div>
            <div class="partners-item">
              <img class="partners-item-icon" :src="IMG_URL+'images/order/tm-icon.png'" alt="">
              <p class="partners-item-name">淘宝</p>
            </div>
            <div class="partners-item">
              <img class="partners-item-icon" :src="IMG_URL+'images/order/jd-icon.png'" alt="">
              <p class="partners-item-name">京东</p>
            </div>
            <div class="partners-item">
              <img class="partners-item-icon" :src="IMG_URL+'images/order/dy-icon.png'" alt="">
              <p class="partners-item-name">抖音</p>
            </div>
            <div class="partners-item">
              <img class="partners-item-icon" :src="IMG_URL+'images/order/ks-icon.png'" alt="">
              <p class="partners-item-name">快手</p>
            </div>
          </div>
        </div>
      </div>
-->
    </div>

    <!-- 新闻模块 -->
    <div class="news" v-if="newsList.length > 0">
      <h3 class="news-title">新闻动态</h3>

      <div class="news-item" v-for="item in newsList" :key="item.id" @click="onSelectData(item)">
        <div class="news-item-top">
          <div class="news-item-title">{{ item.title }}</div>
          <div class="news-item-time">{{ item.createtime.substring(0, 10) }}</div>
        </div>
        <div class="news-item-content" v-html="item.content"></div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose" :title="detail.title" class="dialog-box" width="60%">
      <div class="news-info">
        <span>阅读量：{{ detail.views }}</span>
        <span>发布时间：{{ detail.createtime }}</span>
      </div>
      <div class="news-detail-content" v-html="detail.content"></div>
    </el-dialog>

    <!--底部-->
    <footer-box></footer-box>

    <mantle ref="mantle"></mantle>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import giftItem from "@/components/giftItem/index";
import footerBox from "@/components/footerBox/index";
import headerBanner from "./components/headerBanner/index";
import Mantle from "@/components/mantle";
import { apiProductList, apiNewsad, apiNewsList } from "@/api/api";
export default {
  name: "index",
  components: { headerNav, headerBanner, giftItem, footerBox, Mantle },
  data() {
    return {
      newsList: [],
      formatTime: "",
      detail: {},
      dialogVisible: false,
    };
  },
  computed: {
    advert() {
      let info = null;
      let advert = {};
      if (this.$store.getters.advert) {
        info = this.$store.getters.advert;
      } else {
        info = localStorage.getItem("advertConfig");
        if (info) {
          info = JSON.parse(info);
        }
      }
      if (info && info.index) {
        // console.log(info.index);
        for (let i = 0; i < info.index.length; i++) {
          advert[info.index[i].key] = info.index[i];
        }
      }
      return advert;
    },
    goodsList() {
      return this.$store.getters.goodsList;
    },
    noticeList() {
      return this.$store.getters.noticeList;
    },
  },
  mounted() {
    this.$store.dispatch("getNewsAd");
    this.$store.dispatch("getProductLst");
    if (!localStorage.getItem("addedWx")) {
      this.$refs.mantle.open();
    }

    // 请求新闻接口
    var param = { limit: 10 };
    apiNewsList(param).then(res => {
      if (res.code === 1) {
        var data = res.data.article_list.data;
        this.newsList = data;
      }
    });
  },
  methods: {
    onJumpPages(url) {
      if (url) {
        this.$router.push(url);
      }
    },
    onSelectData(item) {
      this.detail = item;
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.detail = {};
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  // background-color: #eeeeee; //国庆主题
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;

  .advert-box {
    width: 1200px;
    height: 150px;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center center;
  }

  .gift-list {
    margin: 20px 0;
    min-height: 400px;

    .advert-item {
      width: 290px;
      height: 360px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
      float: left;
      margin-right: 13px;
      margin-bottom: 13px;
    }
  }
  .gift-list > div:nth-child(4n + 0) {
    margin: 0;
  }

  .partners {
    margin-top: 30px;
    background-color: #f5f6f7;
    padding: 5px;

    .partners-top {
      padding: 30px 30px 15px;

      p {
        margin: 0;
        text-align: center;
      }
      .partners-top-title {
        color: #000000;
        font-size: 28px;
        font-weight: bolder;
      }
      .partners-top-tips {
        font-weight: bold;
        font-size: 12px;
        margin-top: 5px;
      }
    }

    .partners-content {
      overflow: hidden;
      background-color: #ffffff;
      padding: 50px 30px;

      .partners-list {
        display: flex;
        align-items: center;
        overflow-y: auto;
        justify-content: space-around;
        padding: 2px;

        .partners-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          flex: none;
          margin-right: 20px;

          .partners-item-icon {
            margin-bottom: 5px;
            border-radius: 5px;
            width: 50px;
            height: 50px;
          }
          .partners-item-name {
            margin: 0;
            font-size: 12px;
            font-weight: bold;
          }
        }
      }
    }
  }
}
.news-info {
  text-align: center;
  margin-bottom: 20px;

  span {
    font-size: 12px;
    color: #878787;
    display: inline-block;
    margin: 0 10px;
  }
}
.news {
  width: 1200px;
  height: 100%;
  overflow: hidden;
  // height: 800px;
  position: relative;
  background-color: #fff;
  margin: 10px auto;
  .news-title {
    padding-top: 10px;
    text-align: center;
    color: #333;
    font-weight: bold;
    font-size: 24px;
  }
  .news-item {
    width: 46%;
    height: 110px;
    float: left;
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    margin: 10px 22px;

    cursor: pointer;
  }
  .news-item-top {
    height: 30px;
    padding: 10px 20px;
    position: relative;
    .news-item-title {
      float: left;
      font-size: 16px;
      font-weight: bold;
    }
    .news-item-time {
      float: right;
      font-size: 12px;
    }
  }
  .news-item-content {
    padding: 0 20px 10px 20px;
    height: 64px;
    // text-indent: 24px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .news-item:last-child {
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue